module.exports = __webpack_public_path__ + "static/7-8c2934ba30efe3c3b969afca7befbe05.jpg";